import { ClarionButtonLink } from '@clarion/ClarionButtonLink';
import { useUserState } from '../../auth/UserState';
import { useWorkspaces } from '../../auth/WorkspaceState';
import { useSideNavigation } from './SideNavigationContext';

export function UserMenu() {
  const { user } = useUserState();
  const { current: workspace, workspaces } = useWorkspaces();
  const { isCollapsed } = useSideNavigation();

  const primaryText =
    workspaces.length === 1 ? workspace?.workspaceName : user?.displayName || 'Account';

  const secondaryText = workspaces.length === 1 ? user?.displayName : '';

  return (
    <ClarionButtonLink
      href="/account"
      icon="user"
      variant="minimal"
      size="large"
      textAlign="left"
      tooltip={isCollapsed ? primaryText : undefined}
      tooltipPlacement="right"
      fill
    >
      {isCollapsed ? null : (
        <div className="min-w-0">
          <div className="truncate text-sm font-medium">{primaryText}</div>
          {secondaryText && <div className="truncate text-xs opacity-70">{secondaryText}</div>}
        </div>
      )}
    </ClarionButtonLink>
  );
}
